/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
const RegexValidators = {
    AlphaNumericMinimumLength2: /.{2,}/,
    AlphaNumericWithDashOrDot: /^[a-zA-Z0-9\-.]+$/,
    BaseNameAndIterationCount: /^(.+?)(?:\s*\((\d+)\))?$/,
    Email: /^(([^<>()[\]\\.,;:\s@\"+]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    FileExtension: /\.[0-9a-z]+$/i,
    Decimal: /[0-9]+(.[0-9]+)?/,
    Numeric: /[0-9]+/,
    IterationCount: /^.+?\s*\((\d+)\)$/,
    PositiveOrNegativeNumber: /^\s?-?[0-9]?\d*(\.)?(\d+)?$/,
    PositiveNumber: /^[+]?([.]\d+|\d+([.]\d+)?)$/,
    PositiveNumberZeroThroughTen: /^([1-9]|10)$/,
    PositiveNumberTwoThroughFive: /^[2-5]$/,
    PositiveNumberFourThroughSix: /^(4(\.\d+)?|5(\.\d+)?|6(\.0+)?$)$/,
    PositiveNumberThreePointTwoThroughFourPointFive: /^(3\.[2-9]\d*|3\.[3-9]\d*|4(\.([0-4]\d*|5(?![1-9])))?|4\.5(0*)?)$/,
    PositiveNumberThreeOrGreater: /(?:[3-9]|[1-9]\d+)/,
    PositiveNumberFiveOrGreater: /(?:[5-9]|[1-9]\d+)/,
    PositiveNumberZeroThroughOne: /^(0?\.(\d*[1-9]\d*|\d+)|1(\.0*)?)$/,
    PositiveNumberZeroThroughOneHundred: /^([0-9]|[1-9][0-9]|100)$/,
    Phone: /(?=(.*\d){8})/,
    Password: /^(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]).{14,}$/,
    SpecialCharacter: /^(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])/,
};

export default RegexValidators;
